import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id')({
  beforeLoad: () => getTitleContextSlice('Mapping'),
  staticData: {
    owner: CodeOwner.DataOnboarding,
  },
});
